// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2IKsz","productName":"Table_productName__6_ZZa"};